// Inventory aggregate routes (PLAN-P3 U1c) — assets / threats / evidence / activities with full
// CRUD (list + create + edit + deactivate) over the tenant-worker via api-client, RLS-scoped.
import { AggregateCrud } from "../lib/aggregate-crud";
import { api } from "../lib/api";
import { TENANT_PATHS } from "@sympllex/api-client";

export function BedrijfsmiddelenRoute() {
  return (
    <AggregateCrud
      title="Bedrijfsmiddelen (assets)" queryKey="bedrijfsmiddelen" basePath={TENANT_PATHS.bedrijfsmiddelen} permPrefix="bedrijfsmiddel"
      listFn={() => api.listBedrijfsmiddelen()} createFn={(i) => api.createBedrijfsmiddel(i as unknown as Parameters<typeof api.createBedrijfsmiddel>[0])}
      fields={[{ key: "name", label: "Name", required: true }, { key: "description", label: "Description", type: "textarea" }, { key: "category", label: "Category" }]}
      serverPaged
      empty="No assets registered yet."
    />
  );
}
export function BedreigingenRoute() {
  return (
    <AggregateCrud
      title="Bedreigingen (threats)" queryKey="bedreigingen" basePath={TENANT_PATHS.bedreigingen} permPrefix="bedreiging"
      listFn={() => api.listBedreigingen()} createFn={(i) => api.createBedreiging(i as unknown as Parameters<typeof api.createBedreiging>[0])}
      fields={[{ key: "name", label: "Name", required: true }, { key: "description", label: "Description", type: "textarea" }, { key: "category", label: "Category" }]}
      serverPaged
      empty="No threats registered yet."
    />
  );
}
export function BewijscontainersRoute() {
  return (
    <AggregateCrud
      title="Bewijscontainers (evidence)" queryKey="bewijscontainers" basePath={TENANT_PATHS.bewijscontainers} permPrefix="bewijscontainer"
      listFn={() => api.listBewijscontainers()} createFn={(i) => api.createBewijscontainer(i as unknown as Parameters<typeof api.createBewijscontainer>[0])}
      fields={[
        { key: "name", label: "Name", required: true },
        { key: "anchorKind", label: "Anchor kind (e.g. verwerking)", required: true },
        { key: "anchorId", label: "Anchor id", required: true },
        { key: "description", label: "Description", type: "textarea" },
      ]}
      serverPaged
      empty="No evidence containers yet."
    />
  );
}
export function ActivitiesRoute() {
  return (
    <AggregateCrud
      title="Activiteiten (activities)" queryKey="activities" basePath={TENANT_PATHS.activities} permPrefix="verwerking"
      listFn={() => api.listActivities()} createFn={(i) => api.createActivity(i as unknown as Parameters<typeof api.createActivity>[0])}
      fields={[{ key: "name", label: "Name", required: true }, { key: "description", label: "Description", type: "textarea" }]}
      serverPaged
      empty="No activities yet."
    />
  );
}
